import { render, staticRenderFns } from "./AddUserAndSubUser.vue?vue&type=template&id=c23d8cdc&"
import script from "./AddUserAndSubUser.vue?vue&type=script&lang=js&"
export * from "./AddUserAndSubUser.vue?vue&type=script&lang=js&"
import style0 from "./AddUserAndSubUser.vue?vue&type=style&index=0&id=c23d8cdc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports